import { useContext } from "react";
import infoIcon from "../../../assets/images/info.svg";
import Context from "../../../context";
export const MessageTitle = () => {
    const { contextState, setContextState } = useContext(Context);
  return (
    <>
        <div className="modal-header__icon-wrapper">
            <img className="modal-header-icon" alt="info" src={infoIcon} /> {contextState.modal.title}
        </div>
    </>
  );
};

export const MessageContent = () => {
    const { contextState, setContextState } = useContext(Context);
  return (
    <>
      <p className="text-center justify-content-center">
          {contextState.modal.content}
      </p>
    </>
  );
};
